import BasicRouterView from "../../components/BasicRouterView.vue";

const relRoutes = {
  path: "rel",
  redirect: { name: "salvos" },
  meta: {
    label: "Relatórios",
    icon: "description",
    show: true,
  },
  component: BasicRouterView,
  children: [
    {
      path: "relatorio/relatorios-salvos",
      name: "salvos",
      meta: {
        label: "Salvos",
        icon: "settings",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/RelatoriosSalvos.vue"),
    },
    {
      path: "relatorio/consumo/:id?",
      name: "consumo",
      meta: {
        label: "Consumo",
        icon: "settings",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/Consumo.vue"),
    },
    {
      path: "relatorio/trocas-produtos-requisicao/:id?",
      name: "trocas-produtos-requisicao",
      meta: {
        label: "Trocas Produtos Requisição",
        icon: "swap_horiz",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "rel" */ "./views/TrocasProdutosRequisicao.vue"
        ),
    },
    {
      path: "relatorio/vouchers-cancelados-rejeitados/:id?",
      name: "vouchers-cancelados-rejeitados",
      meta: {
        label: "Vouchers Cancelados/Rejeitados",
        icon: "cancel",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "rel" */ "./views/VouchersCanceladosRejeitados.vue"
        ),
    },
    {
      path: "relatorio/permissao-de-trabalho/:id?",
      name: "permissaodetrabalho",
      meta: {
        label: "Permissão de Trabalho",
        icon: "security",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/PermissaoDeTrabalho.vue"),
    },
    {
      path: "relatorio/relatorio-geral-pt/:id?",
      name: "relatoriogeral-pt",
      meta: {
        label: "Relatório PTs",
        icon: "assignment",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/RelatorioGeralPT.vue"),
    },
    {
      path: "relatorio/relatorio-atividades-pt/:id?",
      name: "relatorioatividades-pt",
      meta: {
        label: "Relatório Atividades",
        icon: "checklist",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "rel" */ "./views/RelatorioAtividadesPT.vue"
        ),
    },
    {
      path: "relatorio/relatorio-participantes-pt/:id?",
      name: "relatorioparticipantes-pt",
      meta: {
        label: "Relatório Participantes",
        icon: "groups",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "rel" */ "./views/RelatorioParticipantesPT.vue"
        ),
    },
    {
      path: "relatorio/master-data/:id?",
      name: "masterdata",
      meta: {
        label: "Master Data",
        icon: "summarize",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/MasterData.vue"),
    },
    {
      path: "relatorio/custos/:id?",
      name: "custos",
      meta: {
        label: "Custos",
        icon: "list",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/Custos.vue"),
    },
    {
      path: "relatorio/custos-consolidado/:id?",
      name: "custos-consolidado",
      meta: {
        label: "Custos Consolidado",
        icon: "list",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/CustosConsolidado.vue"),
    },
    {
      path: "relatorio/necessidade-compra/:id?",
      name: "necessidadecompra",
      meta: {
        label: "Necessidade Compra",
        icon: "fact_check",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/NecessidadeCompra.vue"),
    },
    {
      path: "relatorio/status-troca/:id?",
      name: "statustroca",
      meta: {
        label: "Status Troca",
        icon: "shopping_basket",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/StatusTroca.vue"),
    },
    {
      path: "relatorio/produto-sem-aberto/:id?",
      name: "produtosemaberto",
      meta: {
        label: "Produtos Em Aberto",
        icon: "inventory_2",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/ProdutosAberto.vue"),
    },

    {
      path: "relatorio/produto-sem-aberto-user-logado/:id?",
      name: "produtosemabertouser",
      meta: {
        label: "Produtos Em Aberto User Logado",
        icon: "inventory_2",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "rel" */ "./views/ProdutosAbertoUserLogado.vue"
        ),
    },
    {
      path: "relatorio/estoque/:id?",
      name: "estoque",
      meta: {
        label: "Estoque",
        icon: "assignment_turned_in",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/Estoque.vue"),
    },
    {
      path: "relatorio/estoque-lote/:id?",
      name: "estoquelote",
      meta: {
        label: "Estoque Lote",
        icon: "content_paste",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/EstoqueLote.vue"),
    },
    {
      path: "relatorio/consumo-lote/:id?",
      name: "consumolote",
      meta: {
        label: "Consumo Lote",
        icon: "assignment_returned",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/ConsumoPorLote.vue"),
    },
    {
      path: "relatorio/ferramenta/:id?",
      name: "ferramentas",
      meta: {
        label: "Ferramentas",
        icon: "construction",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/Ferramentas.vue"),
    },
    {
      path: "relatorio/liberacao-fora-prazo/:id?",
      name: "liberacaoforaprazo",
      meta: {
        label: "Liberação Fora do Prazo",
        icon: "build",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/LiberacaoForaPrazo.vue"),
    },
    {
      path: "relatorio/transferencia-ferramenta/:id?",
      name: "transferenciaferramentas",
      meta: {
        label: "Transferência Ferramentas",
        icon: "hardware",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "rel" */ "./views/TransferenciaFerramentas.vue"
        ),
    },
    {
      path: "relatorio/estoque-localizacao/:id?",
      name: "estoquelocalizacao",
      meta: {
        label: "Estoque Localização",
        icon: "location_on",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/EstoqueLocalizacao.vue"),
    },
    {
      path: "relatorio/seguranca-emocional/:id?",
      name: "segurancaemocional",
      meta: {
        label: "Segurança Emocional",
        icon: "emoji_emotions",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/SegurancaEmocional.vue"),
    },
    {
      path: "relatorio/emprestimo-ferramenta/:id?",
      name: "emprestimo-ferramenta",
      meta: {
        label: "Emprestimo Ferramenta",
        icon: "plumbing",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "rel" */ "./views/EmprestimoFerramenta.vue"
        ),
    },
    {
      path: "relatorio/movimentacao-statu/:id?",
      name: "movimentacao-status",
      meta: {
        label: "Movimentação de Status",
        icon: "signal_wifi_statusbar_null",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/MovimentacaoStatus.vue"),
    },
    {
      path: "relatorio/regras-troca/:id?",
      name: "regras-trocas",
      meta: {
        label: "Regras de Trocas",
        icon: "gavel",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/RegrasTrocas.vue"),
    },

    {
      path: "relatorio/movimentacao-estoque-manual/:id?",
      name: "movimentacao-manual",
      meta: {
        label: "Movimentação de Estoque Manual",
        icon: "gavel",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/MovimentacaoManual.vue"),
    },
    {
      path: "relatorio/devolucao-material/:id?",
      name: "devolucao-materiais",
      meta: {
        label: "Devolução de Materiais",
        icon: "sync_alt",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/DevolucaoMateriais.vue"),
    },
    {
      path: "relatorio/estoque-consolidado/:id?",
      name: "estoque-consolidado",
      meta: {
        label: "Estoque Consolidado",
        icon: "inventory",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/EstoqueConsolidado.vue"),
    },
    {
      path: "relatorio/relatorio-mrp/:id?",
      name: "relatorio-mrp",
      meta: {
        label: "Relatório MRP",
        icon: "shopping_cart_checkout",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/RelatorioMrp.vue"),
    },
    {
      path: "relatorio/transferencia-estoque/:id?",
      name: "transferencia-estoque",
      meta: {
        label: "Transferência Estoque",
        icon: "transfer_within_a_station",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "rel" */ "./views/TransferenciaEstoque.vue"
        ),
    },
    {
      path: "relatorio/entrada-nf/:id?",
      name: "entrada-nf",
      meta: {
        label: "Entrada NF",
        icon: "meeting_room",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/EntradaNf.vue"),
    },
    {
      path: "relatorio/retirada-sem-biometria/:id?",
      name: "retirada-sem-biometria",
      meta: {
        label: "Retiradas sem Biometria",
        icon: "assignment_return",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "rel" */ "./views/RetiradasSemBiometria.vue"
        ),
    },
    {
      path: "relatorio/treinamento/:id?",
      name: "relatorio-treinamento",
      meta: {
        label: "Treinamento",
        icon: "directions_run",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/Treinamento.vue"),
    },
    {
      path: "relatorio/centro-custo/:id?",
      name: "relatorio-centro-custo",
      meta: {
        label: "Centro de Custo",
        icon: "business",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/CentroDeCustos.vue"),
    },
    {
      path: "relatorio/categoria/:id?",
      name: "relatorio-categoria",
      meta: {
        label: "Categoria",
        icon: "category",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/Categorias.vue"),
    },
    {
      path: "relatorio/fornecedor/:id?",
      name: "relatorio-fornecedores",
      meta: {
        label: "Fornecedores",
        icon: "local_shipping",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/Fornecedores.vue"),
    },
    {
      path: "relatorio/grupo-produto/:id?",
      name: "relatorio-grupo-produto",
      meta: {
        label: "Grupo Produto",
        icon: "shopping_cart_checkout",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/GrupoProduto.vue"),
    },
    {
      path: "relatorio/notificacao/:id?",
      name: "relatorio-notificacao",
      meta: {
        label: "Notificação",
        icon: "notifications",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/Notificacao.vue"),
    },
    {
      path: "relatorio/itens-nao-codificados-compra/:id?",
      name: "relatorio-itens-nao-codificados-compra",
      meta: {
        label: "Itens Não Codificados Compra",
        icon: "integration_instructions",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "rel" */ "./views/ItensNaoCodificadosCompra.vue"
        ),
    },
    {
      path: "relatorio/itens-codificados-compra/:id?",
      name: "relatorio-itens-codificados-compra",
      meta: {
        label: "Itens Codificados Compra",
        icon: "integration_instructions",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "rel" */ "./views/ItensCodificadosCompra.vue"
        ),
    },
    {
      path: "relatorio/ghe/:id?",
      name: "relatorio-ghe",
      meta: {
        label: "GHE",
        icon: "receipt_long",

        show: true,
      },
      component: () => import(/* webpackChunkName: "rel" */ "./views/Ghe.vue"),
    },
    {
      path: "relatorio/autenticacao/:id?",
      name: "relatorio-autenticacoes",
      meta: {
        label: "Autenticações",
        icon: "assignment_late",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/Autenticacoes.vue"),
    },
    {
      path: "relatorio/custos-nf-voucher/:id?",
      name: "relatorio-custos-nf-voucher",
      meta: {
        label: "Custos NF e Voucher",
        icon: "auto_graph",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/CustosNfVoucher.vue"),
    },
    {
      path: "relatorio/documentos/:id?",
      name: "relatorio-documentos",
      meta: {
        label: "Documentos",
        icon: "folder",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/Documentos.vue"),
    },
    {
      path: "relatorio/tipo/:id?",
      name: "relatorio-tipo",
      meta: {
        label: "Tipo Documento",
        icon: "widgets",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/TipoDocumento.vue"),
    },
    {
      path: "relatorio/categoria-documento/:id?",
      name: "relatorio-categoria-documento",
      meta: {
        label: "Categoria Documento",
        icon: "category",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/CategoriaDocumento.vue"),
    },
    {
      path: "relatorio/documento-vinculado/:id?",
      name: "relatorio-documento-vinculado",
      meta: {
        label: "Documento Vinculado",
        icon: "note_add",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "rel" */ "./views/DocumentoVinculado.vue"),
    },
  ],
};

export default relRoutes;
